<template>
    <div :class="['filter-swatch-element', disabled(swatches.value) ? 'disabled': '']" :status="active(swatches.value)" @click="select(swatches.value)">
        <template v-for="swatch in swatches.colors">
            <div class="swatch" :style="`background-color: #${swatch}`"></div>
        </template>
        <div class="swatch--status" ></div>
    </div>
</template>

<script>
    import { constants } from "@productfinder/shared/constants";

    export default {
        name: "sal-filter-swatch-element",
        props: {
            swatches: {},
            name: '',
            status: String
        },
        methods: {
            select(value) {
                if (!this.disabled(value)){
                    if (this.$store.state.filterStates[this.name] && this.$store.state.filterStates[this.name].some((element) => {return element === value})) {
                        this.$store.dispatch('removeFilterState', { filterName: this.name, value: value });
                    } else {
                        this.$store.dispatch('setFilterState', { filterName: this.name, value: value });
                    }
                }
            },
            active(value) {
                if (this.status === constants.swatchStatus.remove) {
                    return constants.swatchStatus.remove
                } else {
                    return this.$store.state.filterStates[this.name] && this.$store.state.filterStates[this.name].some(el => {return el === value}) ? constants.swatchStatus.selected : '';
                }
            },
            disabled(value) {
                const filter = this.$store.getters.getAvailableOptions[this.name];
                if (filter) {
                    return !filter.some(filterValue => {

                        if(filterValue === value) {
                            return true
                        }
                    });
                }
                return true
            }
        }
    }
</script>
